export default __webpack_public_path__ + "static/media/oops-are-you-lost.d4a6bc83.svg";